
import { ContractData, CustomerWebAppData, SiteWebAppData } from 'app/core/hub-api';

export class OpenCloseContractModalContext {
  openMode: boolean;
  contract: ContractData;
  customers: CustomerWebAppData[];
  site: SiteWebAppData;
}
